import { ReactElement } from 'react';
import { RouteObject } from 'react-router';
import { useParams } from 'react-router-dom';
import invariant from 'tiny-invariant';
import { BlockProvider } from './BlockProvider';
import { Agreement, History, Tasks } from './views';
import { Plan } from '../plan';

function RoutedBlockProvider(): ReactElement {
  const { block_id } = useParams<'block_id'>();
  invariant(block_id);

  return <BlockProvider key={block_id} />;
}

export const route: RouteObject = {
  path: 'planning/:block_id/*',
  element: <RoutedBlockProvider />,
  children: [
    {
      index: true,
      element: <Plan />,
    },
    {
      path: 'tasks/:task_id?',
      element: <Tasks />,
    },
    {
      path: 'agreement',
      element: <Agreement />,
    },
    {
      path: 'history',
      element: <History />,
    },
  ],
};
